import { AuthEvmSignatureResponseSchema } from '@rhinofi/authentication-api-spec'
import { Schema } from 'effect'

export const AuthDataSchema = Schema.Struct({
  ...AuthEvmSignatureResponseSchema.fields,
  createdAt: Schema.DateFromString,
})

export type AuthDataType = typeof AuthDataSchema.Type
